import { createEnum } from "@redotech/zod/zod-enum";
import * as z from "zod/v4";

export const getEstimatedAnnualRevenue = {
  name: "getEstimatedAnnualRevenue" as const,
  input: z.object({}),
  output: z.object({
    annualRevenue: z.number().nullable(),
    dataAvailable: z.boolean(),
    reason: createEnum(["no_data", "invalid_data"]).optional(),
  }),
};
